<app-form-wrapper title="Summary">
  <div class="pv">
    <div class="pv__fact">
      <p class="pv__label">Campaign</p>
      <p class="pv__value pv__value--strong" [class.is-empty]="!details.campaignName">
        {{ details.campaignName || "Untitled campaign" }}
      </p>
    </div>

    <div class="pv__fact">
      <p class="pv__label">Description</p>
      <p class="pv__value" [class.is-empty]="!details.description">
        {{ details.description || "What the campaign is for appears here." }}
      </p>
    </div>

    <div class="pv__fact">
      <p class="pv__label">Goals</p>
      @if (goals.length) {
        <ul class="pv__list">
          @for (goal of goals; track $index) {
            <li>{{ goal }}</li>
          }
        </ul>
      } @else {
        <p class="pv__empty">Add at least one goal, so the team knows what success looks like.</p>
      }
    </div>
  </div>
</app-form-wrapper>
